"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateFeature = exports.isFeatureFlag = exports.featureFlagSchema = void 0;
var yup = require("yup");
exports.featureFlagSchema = yup.object().shape({
    name: yup.string().required(),
    from: yup.number().required(),
    to: yup.number().required(),
    countryIds: yup.array().of(yup.string()).optional(),
    minVersion: yup.string().optional(),
});
function isFeatureFlag(obj) {
    return exports.featureFlagSchema.isValidSync(obj);
}
exports.isFeatureFlag = isFeatureFlag;
function validateFeature(obj) {
    return exports.featureFlagSchema.validateSync(obj);
}
exports.validateFeature = validateFeature;
